import React from "react";
import { IonCol, IonGrid, IonImg, IonInput, IonItem, IonLabel, IonRow } from '@ionic/react';
import i18n from '../../../../i18n';
import { Anywhere, CityError } from "../../../utils/constants";
import { onFocusOut, citySelected } from './origin.util';
export interface NewInputProps {
  disabled?: boolean;
  currentLocationOff?: boolean;
  onTimeZoneChange?: (timezone: string) => void;
  Error: any;
  labelValue: any;
  InputValue: any;
  handleChange: any;
  InputName: any;
  keyboardshowHandler?: any;
  keyboardhideHandler?: any;
  isDestination: boolean;
  deFaultValue: any;
  useHandler: boolean;
  setErrorValue: any;
  locationValue: boolean;
  getLocalTime?: any;
  placeholder?: string;
  confirmStartLocationInp?: boolean;
  onFocus?: Function;
  country?: string;
  postalCode?: string;
  isCapacitor?: boolean,
  allowAnywhere?: boolean,
}
export const GetUiElements: React.FC<any> = (Props) => {
  const {
    labelValue,
    Error,
    showError,
    handleValueChange,
    selectedCity,
    inputPalceholder,
    showSuggention,
    currentLocation,
    options,
    setSelectedCity,
    setEdited,
    setBackClicked,
    setFocusOut,
    focusOut,
    setShowSuggention,
    setShowError,
    setErrorValue,
    setCountry,
    setPostalCode,
    setSelect,
    setLatLng,
    disabled,
    InputName,
    onFocus,
    isDestination,
    deFaultValue,
    locationValue,
    InputValue,
    allowAnywhere = false,
    select,
  } = Props;
  const selectCity = (SearchCity: any) => {
    citySelected(SearchCity, setSelectedCity, setCountry, setPostalCode, setShowSuggention, setSelect, setLatLng, Props)
  }
  return (
    <>
      <IonItem
        mode="ios"
        className={`typeahead-item ${
          (Error || showError)
            ? "ion-error-field-validation"
            : "ion-field-validation"
        }`}
      >
        {labelValue.length > 0 ? (
          <IonLabel mode="ios" position="floating">
            {labelValue}
          </IonLabel>
        ) : null}

        <IonInput
        data-testid="originInput"
          type="text"
          disabled={disabled}
          className={"cts-form-control"}
          name={InputName}
          onIonChange={event => handleValueChange(event)}
          value={selectedCity}
          placeholder={inputPalceholder}
          onIonFocus={() => typeof onFocus === 'function' && onFocus()}
          onIonBlur={() =>
            onFocusOut(
              Props,
              setFocusOut,
              setShowSuggention,
              options,
              selectedCity,
              currentLocation,
              setShowError,
              setErrorValue,
              setBackClicked,
              setSelectedCity,
              select
            )
          }
          onClick={() => {
            if (
              focusOut ||
              currentLocation.cityName === selectedCity ||
              ((isDestination || allowAnywhere) && selectedCity === Anywhere)
            ) {
              setSelectedCity("");
              setEdited(true);
              setBackClicked(true);
              setFocusOut(false);
            }
          }}
        >
          <IonImg
            slot="end"
            alt="logo"
            src="/assets/icon/search_icon.svg"
            className="origin-input_icon"
          />
        </IonInput>
        {(isDestination || allowAnywhere) && selectedCity !== "" ? (
          <IonImg
            slot="end"
            alt="logo"
            src="/assets/icon/cancel.svg"
            className="destination-input_icon"
            onClick={() => setSelectedCity(Anywhere)}
          />
        ) : null}
      </IonItem>
      {options.length === 0 && (
        <div className="pickupdate-error">
          {typeof Error === "string" ? (
            <p>{Error}</p>
          ) : showError ? (
            <p>{i18n.t(CityError)}</p>
          ) : null}
        </div>
      )}
      {showSuggention ? (
        <div className="suggestion-startTrip">
          <IonRow className="suggestions_row">
            {!locationValue && currentLocation.cityName && (
              <IonCol class="icon-col">
                <IonImg
                  alt="logo"
                  src="/assets/icon/position.svg"
                  className="position_icon"
                />
              </IonCol>
            )}
            <IonCol class="suggestion-col">
              {currentLocation.cityName ? (
                <IonRow
                  className={` ${
                    locationValue ? "current-location2" : "current-location "
                  }`}
                  onMouseDown={() =>
                    currentLocation && selectCity(currentLocation)
                  }
                >
                  <IonCol className="currentLocation-col">
                    {!locationValue ? (
                      <IonLabel position="floating">
                        {i18n.t("Current Location")}
                      </IonLabel>
                    ) : null}
                    <IonInput
                      className={`${
                        locationValue ? "suggestion-border" : "cts-form-control"
                      }`}
                      type="text"
                      value={
                        locationValue ? InputValue : currentLocation.cityName
                      }
                      readonly
                    />
                  </IonCol>
                </IonRow>
              ) : null}
              {allowAnywhere ? (
                <IonRow
                  className="suggestions_item"
                  onMouseDown={() => selectCity({ cityName: deFaultValue })}
                >
                  <IonCol class="suggestions_list">
                    {i18n.t(deFaultValue)}
                  </IonCol>
                </IonRow>
              ) : (
                ""
              )}
              {options.length ? (
                <IonGrid
                  class={`suggestions ${
                    isDestination ? "destination_suggestions" : ""
                  } ${locationValue ? "suggestions-pad" : ""}`}
                >
                  {options.map((SearchCity: any, index: number) => (
                    <IonRow
                      className="suggestions_item"
                      key={index}
                      onMouseDown={() => selectCity(SearchCity)}
                    >
                      <IonCol class="suggestions_list">
                        {SearchCity.cityName}
                      </IonCol>
                    </IonRow>
                  ))}
                </IonGrid>
              ) : (
                !locationValue && (
                  <div className="pickupdate-error_div">
                    <p>{i18n.t("CityError")}</p>
                  </div>
                )
              )}
            </IonCol>
          </IonRow>
        </div>
      ) : null}
    </>
  );
}